<template>
    <div class="contact-form">
      <div class="form-content">
        <span v-if="!isLoggedIn">
            <Input type="text" label="Your Name (required)" v-model="contactName" required />
            <Input type="email" label="Your Email (required)" v-model="contactEmail" required />
        </span>  

        <textarea v-model="contactMessage" placeholder="Your Message" required></textarea>
        <span v-if="!isLoggedIn" class="privacy-wrap">
            <input type="checkbox" id="privacy" v-model="privacyAgreed" required>
            <label for="privacy">I agree that my data is used to process my request. Please read our <NuxtLink href="/privacypolicy">privacy policy</NuxtLink>.</label>
        </span>
      </div>
      <div class="button-group">
        <button @click="submitContactForm" class="fa-btn fa-btn-primary" :disabled="isSubmitted">Send Message</button>
      </div>
      <ModalMessage :message="feedbackMessage" :type="feedbackType" class="modal-message"/>
    </div>
  </template>
  
  <script setup>
  import { ref } from 'vue';
  import { useUserStore } from '~/store/userStore';
  import { useUIStore } from '~/store/uiStore';

  const uiStore = useUIStore();

const userStore = useUserStore();

const isLoggedIn =  computed(() => userStore.userData?.is_logged_in || false);
const userData = computed(() => userStore.userData);
const isSubmitted = ref(false);
 

  const contactName = ref('');
  const contactEmail = ref('');
  const contactMessage = ref(uiStore.modalMessage || '');
  const privacyAgreed = ref(false);
  const feedbackMessage = ref('');
  const feedbackType = ref('');
  
  const resetValidationFeedback = () => {
  feedbackMessage.value = '';
  feedbackType.value = '';
};

const validateForm = () => {
  resetValidationFeedback();

  // Validate privacy policy agreement
  if (!isLoggedIn.value && !privacyAgreed.value) {
    feedbackMessage.value = 'Please agree to the privacy policy.';
    feedbackType.value = 'error';
    return false;
  }

    // Validate non-empty name
    if (!contactName.value.trim()) {
        feedbackMessage.value = 'Please enter your name.';
        feedbackType.value = 'error';
        return false;
    }

    // Validate email using a simple regex pattern
    const emailPattern = /^\S+@\S+\.\S+$/;
    if (!emailPattern.test(contactEmail.value)) {
        feedbackMessage.value = 'Please enter a valid email address.';
        feedbackType.value = 'error';
        return false;
    }
    // Validate non-empty message
  if (!contactMessage.value.trim()) {
    feedbackMessage.value = 'Please enter your message.';
    feedbackType.value = 'error';
    return false;
  }

  // If all validations pass
  return true;
};


  const submitContactForm = () => {
  // Assume we have all the contact form data in contactFormData object

      // If the user is logged in, override name and email with userData
  if (isLoggedIn.value) {
    contactName.value = userData.value.name;
    contactEmail.value = userData.value.email_address;
  }

  const contactFormData = {
    name: contactName.value,
    email: contactEmail.value,
    subject: "Contact Form",
    message: contactMessage.value
  };


  if (!validateForm()) {
    // If validation fails, exit the function
    return;
  }

  // Send the contact form data using fetch API
  fetch(`${import.meta.env.VITE_WP_BASE_URL}/wp-json/fa/v1/submit-contact-form`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': import.meta.env.VITE_WP_TOKEN
    },
    body: JSON.stringify(contactFormData)
  })
  .then(response => {
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    return response.json();
  })
  .then(data => {
    // Reset the form or update the UI to indicate successful submission
    feedbackMessage.value = 'Thank you for your message. We will be in touch soon!';
    feedbackType.value = 'success';
    isSubmitted.value = true; // Set isSubmitted to true on successful submission
  })
  .catch(error => {
    // Handle any errors that occurred during the submission
    feedbackMessage.value = 'There was an error submitting the form. Please try again.';
    feedbackType.value = 'error';
  });
};

  
  </script>
  
  <style lang="scss" scoped>
  @import '~/assets/constants.scss';

// Adjust the selector based on how dark-mode is applied in your application
// You may need to adjust if dark-mode is set on a parent element or through a different mechanism

  .contact-form {
    /* Styles for your form */
  }
  
  .form-content {
    /* Styles for the form content area */
  }
  
  .button-group {
    margin-top: 1rem;
  }

  .modal-message {
    margin-top: 1rem;
  }
  </style>
  